import BaseException from "exceptions/BaseException";

export default class InvalidFilterTypeException extends BaseException {
    readonly name = 'InvalidFilterTypeException';
}
